<template>
    <v-card outlined>
        <v-card-text>
            <!-- PANEL DE CLIENTE INTEGRADO -->
            <v-row dense align="center" class="pa-2">
                <v-col cols="12">
                    <ClientePanel v-model="datos.idCliente" />
                </v-col>
                <v-col cols="12" sm="6">
                    <ul class="mt-3">
                        <li><strong>Correo:</strong> {{ datos.emailClient || 'N/A' }}</li>
                        <li><strong>Teléfono:</strong> {{ datos.phoneClient || 'N/A' }}</li>
                    </ul>
                </v-col>
                <v-col cols="12" sm="6" class="text-right">
                    <v-btn class="green my-2" dark @click="generateOS">GENERAR ORDEN SERVICIO</v-btn>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-text>
            <v-row dense align="center" class="pa-2">
                <v-col cols="12" sm="12">
                    <v-row dense>
                        <v-col cols="12" sm="4">
                            <v-autocomplete dense v-model="isDepartamento" :items="departamentos" item-text="name"
                                placeholder="Departamento" item-value="id" label="Departamento" autocomplete="nope"
                                outlined />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-autocomplete autocomplete="nope" dense v-model="isProvincia" :items="provincias"
                                item-text="name" placeholder="provincia" item-value="id" outlined label="Provincia" />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-autocomplete autocomplete="nope" dense v-model="isDistrito" :items="distritos"
                                item-text="name" outlined item-value="id" label="Distrito" />
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-text-field outlined dense v-model="datos.direccion" label="Dirección de envío"
                        placeholder="direccion" />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field outlined dense v-model="datos.atributos.documentoReceptor" label="DNI/RUC (Recibe)" />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field outlined dense v-model="datos.atributos.fullNameReceptor"
                        label="Nombre/Razon Social (Recibe)" />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field outlined dense v-model="datos.celularContacto" label="Celular (Recibe)" />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-autocomplete outlined dense v-model="datos.atributos.encargadoOrdenServicio" :items="personal"
                        label="Encargado Orden Servicio"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field outlined dense v-model="datos.atributos.horaVisitaInicio" type="time"
                        label="Hora Inicio Visita" />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field outlined dense v-model="datos.atributos.horaVisitaFin" type="time"
                        label="Hora Fin Visita" />
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-text>
            <v-row dense justify="end">
                <v-col cols="auto">
                    <v-btn color="primary" dark class="mr-2" @click="enviarCorreoVisita" :loading="loadingCorreo">
                        <v-icon left>mdi-email</v-icon> CORREO
                    </v-btn>
                    <v-btn color="green" dark @click="enviarWhatsAppVisita">
                        <v-icon left>mdi-whatsapp</v-icon> WHATSAPP
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-text class="lightenPrimary">
             <v-card outlined>
                <v-tabs v-model="subTab" background-color="secondaryTheme" dark slider-color="primary" grow show-arrows>
                    <v-tab>SERVICIOS</v-tab>
                </v-tabs>
            </v-card>
        </v-card-text>
        <v-card-text class="grey lighten-4" elevation="2">
            <v-row>
                <v-col cols="12" sm="4">
                    <v-list two-line>
                        <template v-for="valProducts in this.listService">
                            <div :key="valProducts.id">
                                <v-list-item>
                                    <v-list-item-content>{{ valProducts.description }} </v-list-item-content>
                                    <v-list-item-action>
                                        <v-btn @click="getService(valProducts)" small>Agregar</v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                            </div>
                        </template>
                        <v-list-item v-if="listService.length === 0">
                            <v-list-item-content>
                                <v-list-item-title>No hay servicios disponibles</v-list-item-title>
                                <v-list-item-subtitle>Agregue productos de tipo servicio (ZZ) a la orden primero</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-col>
                <v-col cols="12" class="grey lighten-5">
                    <v-data-table multi-sort :headers="headers" :items="listServiceItems" class="elevation-1"
                        :items-per-page="20" item-key="index">
                        <template v-slot:[`item.action`]="{ item, index }">
                            <v-icon color="primary" small @click="deleteItem(item, index)">mdi-delete </v-icon>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>
<script>

import { sleep } from '@/utils/genericUtils'
import { format, differenceInDays, parseISO } from 'date-fns'
import { mapGetters, mapState, mapActions } from 'vuex'
import request from '@/utils/request'
import ClientePanel from '@/components/clientes/ClientePanel'
import SelectPrivados from '@/components/selects/SelectPrivados'
import SelectProductos from '@/components/selects/SelectProductos'
import { mixins } from '@/mixins/mixin.js'
import { debounce } from 'lodash'

export default {
    components: {
        SelectPrivados,
        ClientePanel,
        SelectProductos
    },
    filters: {},
    mixins: [mixins],
    $_veeValidate: {
        validator: 'new'
    },
    data() {
        return {
            subTab: 0,
            date: new Date(),
            dialog: false,
            textHours: '',
            loadingCorreo: false,
            listAllService: this.datos?.service || null,
            menu: false,
            menu2: false,
            menu3: false,
            isDepartamento: null,
            isProvincia: null,
            isDistrito: null,
            time: format(new Date(), 'HH:mm'),
            selectCliente: [
                { id: 1, text: 'NUEVO' },
                { id: 2, text: 'FRECUENTE' }
            ],
             customData: null,
            listaProdReserva: [],
            headers: [
                { text: 'SLOT', value: 'rename' },
                { text: 'Descripción', value: 'description' },
                { text: 'Duración', value: 'hoursTime' },
                { text: 'UNID', value: 'quantity' },
                { text: 'P. UNIT (S/)', value: 'price' },
                { text: 'Comision', value: 'comision' },
                { text: 'Descuento', value: 'descuentos' },

                { text: 'SUBTOTAL', value: 'subTotal' },
                { text: 'Actions', value: 'action', sortable: false }
            ]
        }
    },
    computed: {
        ...mapState('ventas', ['datos', 'productos']),
        ...mapState('users', ['user', 'personal']),
        ...mapState('sedes', ['sedes', 'departamentos', 'provincias', 'distritos']),
        ...mapState('utilities', ['itemServices']),
        check_in: {
            get() {
                return this.datos.check_in
            },
            set(v) {
                //console.log('set')
                this.$store.commit('ventas/UPDATE_DATOS', {
                    check_in: format(parseISO(v), 'yyyy-MM-dd')
                })
            }
        },
        listService() {
            console.log('=== COMPUTED listService EJECUTADO ===')
            console.log('productos del store:', this.productos)
            let service = []
            if (this.productos?.length > 0) {
                console.log('Hay productos, cantidad:', this.productos.length)
                this.productos.forEach((element, index) => {
                    console.log(`Producto ${index}:`, {
                        id: element.id,
                        description: element.description,
                        unit_type_id: element.unit_type_id,
                        tipo: typeof element.unit_type_id
                    })
                    if (element.unit_type_id == 'ZZ') {
                        console.log('✓ Producto agregado a service')
                        service.push(element)
                    }
                })
            } else {
                console.log('productos está vacío o es null/undefined')
            }
            console.log('listService resultado final:', service)
            console.log('=== FIN listService ===')
            return service
        },
        listServiceItems() {
            const list = []
            //console.log('payload---', this.listAllService)
            list.push(this.listAllService)
            this.datos.service = list
            //console.log("datos--",this.datos)
            return list
        },
        idCliente() {
            return this.datos.idCliente
        },
        horaVisitaRango() {
            const inicio = this.datos.atributos?.horaVisitaInicio || ''
            const fin = this.datos.atributos?.horaVisitaFin || ''
            if (inicio && fin) return `${inicio} - ${fin}`
            return inicio || fin || ''
        }
    },
    async mounted() {
        this.customData = null
        await this.$store.dispatch('utilities/itemServices')
     },
      watch: {
          async isDepartamento(val) {
              //console.log('isDepartamento ', val)
              if (val) {
                  await this.$store.dispatch('sedes/getProvincia', val)
              }
          },
          async isProvincia(val) {
              //console.log('provincia ', val)
             if (val) {
                 await this.$store.dispatch('sedes/getDistrito', val)
             }
         },
         async isDistrito(val) {
             //console.log('distrito ', val)
             if (val) {
                 this.$store.commit('ventas/UPDATE_DATOS', {
                     ubigeo: val
                 })
             }
         },
         check_in(val) {
             const validaDate = differenceInDays(parseISO(val), format(new Date(), 'yyyy-MM-dd')) > 0
             if (validaDate) {
                 this.$store.commit('ventas/UPDATE_DATOS', {
                     tipoVenta: 2
                 })
             } else {
                 this.$store.commit('ventas/UPDATE_DATOS', {
                     tipoVenta: 1
                 })
             }
         }
     },
    async created() {
        // getListaCli removed — client data populated via ClientePanel + ventas store
        this.datos.atributos.DocumentoRegistro = { ...this.datos.atributos, ...this.datos.atributos.DocumentoRegistro }
        // Asegurar claves reactivas para la hora de visita (Vue 2 no detecta propiedades nuevas)
        if (this.datos.atributos.horaVisitaInicio === undefined) {
            this.$set(this.datos.atributos, 'horaVisitaInicio', null)
        }
        if (this.datos.atributos.horaVisitaFin === undefined) {
            this.$set(this.datos.atributos, 'horaVisitaFin', null)
        }
        await Promise.all([
            this.$store.dispatch('sedes/getDepartamento', { online: true }),
            this.$store.dispatch('users/getPersonas'),
            this.$store.dispatch('users/getLista')
        ])

        if (this.datos.ubigeo) {
            this.isDepartamento = this.datos.ubigeo.slice(0, 2)
            this.isProvincia = this.datos.ubigeo.slice(0, 4)
            this.isDistrito = this.datos.ubigeo
        }
     },
      methods: {
          ...mapActions({ postAddOS: 'inventario/postAddOS' }),

          enviarWhatsAppVisita() {
            const encargado = this.datos.atributos?.encargadoOrdenServicio || ''
            const fecha = this.datos.check_in || ''
            const hora = this.horaVisitaRango
            const direccion = this.datos.direccion || ''
            const receptor = this.datos.atributos?.fullNameReceptor || ''
            const celular = this.datos.celularContacto || ''

            // Construir dirección completa
            let dirCompleta = direccion
            try {
                const distrito = this.distritos.find((x) => x.id == this.isDistrito)?.name || ''
                const provincia = this.provincias.find((x) => x.id == this.isProvincia)?.name || ''
                const departamento = this.departamentos.find((x) => x.id == this.isDepartamento)?.name || ''
                dirCompleta = [direccion, distrito, provincia, departamento].filter(Boolean).join(', ')
            } catch (e) {
                console.warn('No se pudo resolver ubigeo completo:', e)
            }

            // Detalle de servicios
            const servicios = this.listServiceItems
                .filter((s) => s && s.description)
                .map((s) => `• ${s.description}`)
                .join('\n') || ''

            // Link de condiciones según empresa
            const esKunte = this.user.idBussines === 4
            const linkCondiciones = esKunte
                ? 'https://kuntesoluciones.com/condiciones-del-servicio'
                : 'https://cubaspa.com.pe/condiciones-del-servicio/'

            const mensaje = `Visita técnica programada

Le confirmamos que su visita técnica ha sido programada con nuestro técnico ${encargado} para el día ${fecha}.

📋 Datos registrados para la visita:

📍 Lugar de instalación: ${dirCompleta}
👤 Persona que recibe al técnico: ${receptor}
📱 Celular de contacto: ${celular}
👨‍🔧 Técnico asignado: ${encargado}
📅 Fecha: ${fecha}
🕐 Horario: ${hora}
🔧 Motivo de la visita:
${servicios}

Por favor, agradeceremos brindar las facilidades necesarias para el ingreso y desarrollo del trabajo, así como procurar que la persona indicada se encuentre disponible para recibir a nuestro técnico.

Antes de la visita, le solicitamos revisar nuestras condiciones del servicio, donde encontrará información importante sobre la atención y el alcance de la visita:
${linkCondiciones}`

            // Validar celular
            const original = String(celular || '')
            const raw = original.replace(/\D+/g, '')
            const normalized = raw.startsWith('51') ? raw : `51${raw}`
            if (!/^51\d{7,12}$/.test(normalized)) {
                this.$store.commit('mainUI/OPEN_MODAL', {
                    state: true,
                    text: 'Error - Número de celular inválido para WhatsApp',
                    color: 'red'
                })
                return
            }

            // Usar encodeURI para preservar emojis correctamente
            const whatsappUrl = `https://wa.me/${normalized}?text=${encodeURI(mensaje)}`
            window.open(whatsappUrl, '_blank')
        },

          async enviarCorreoVisita() {
            this.loadingCorreo = true
            try {
                const encargado = this.datos.atributos?.encargadoOrdenServicio || ''
                const fecha = this.datos.check_in || ''
                const hora = this.horaVisitaRango
                const direccion = this.datos.direccion || ''
                const receptor = this.datos.atributos?.fullNameReceptor || ''
                const celular = this.datos.celularContacto || ''
                const email = this.datos.emailClient || ''
                const clienteNombre = this.datos.full_name || ''
                const ticket = this.datos.id || ''

                if (!email) {
                    this.$store.commit('mainUI/OPEN_MODAL', {
                        state: true,
                        text: 'El cliente no tiene correo registrado',
                        color: 'red'
                    })
                    return
                }

                // Construir dirección completa
                let dirCompleta = direccion
                try {
                    const distrito = this.distritos.find((x) => x.id == this.isDistrito)?.name || ''
                    const provincia = this.provincias.find((x) => x.id == this.isProvincia)?.name || ''
                    const departamento = this.departamentos.find((x) => x.id == this.isDepartamento)?.name || ''
                    dirCompleta = [direccion, distrito, provincia, departamento].filter(Boolean).join(', ')
                } catch (e) {
                    console.warn('No se pudo resolver ubigeo:', e)
                }

                // Detalle de servicios (solo texto, el template se encarga del HTML)
                const servicios = this.listServiceItems
                    .filter((s) => s && s.description)
                    .map((s) => s.description)

                // Link de condiciones según empresa
                const esKunte = this.user.idBussines === 4
                const serviceId = esKunte ? 4 : 2
                const linkCondiciones = esKunte
                    ? 'https://kuntesoluciones.com/condiciones-del-servicio'
                    : 'https://cubaspa.com.pe/condiciones-del-servicio/'

                // Separar rango de horas
                const [horaInicio = '', horaFin = ''] = (hora || '').split(' - ').map((h) => h.trim())

                // Sede y vendedora para el pie del correo
                let sede = ''
                try {
                    sede = this.sedes.find((x) => x.id == this.user.idSede)?.sede_name_id || ''
                } catch (e) { /* sede opcional */ }
                const vendedora = [this.user.nombres, this.user.apellidos].filter(Boolean).join(' ')

                const asunto = `Confirmación de visita técnica – N.° ${ticket}`

                const body = {
                    payload: {
                        destinatarios: email,
                        asunto: asunto,
                        visitaData: {
                            ticket,
                            clienteNombre,
                            tecnico: encargado,
                            fecha,
                            horaInicio,
                            horaFin,
                            direccion: dirCompleta,
                            receptor,
                            celular,
                            servicios,
                            esKunte,
                            linkCondiciones,
                            sede,
                            vendedora
                        }
                    },
                    setup: {
                        serviceId: serviceId,
                        template: 'visita_tecnica'
                    }
                }

                const { data } = await request({
                    url: '/api-orquestador/email/v2.0/send',
                    method: 'POST',
                    headers: { 'content-type': 'application/json' },
                    data: body
                })

                if (data.success) {
                    this.$store.commit('mainUI/OPEN_BAR', {
                        state: true,
                        text: 'Correo de visita técnica enviado correctamente',
                        color: 'green'
                    })
                } else {
                    this.$store.commit('mainUI/OPEN_BAR', {
                        state: true,
                        text: 'Error al enviar el correo',
                        color: 'red'
                    })
                }
            } catch (error) {
                console.error('Error enviando correo:', error)
                this.$store.commit('mainUI/OPEN_BAR', {
                    state: true,
                    text: 'Error al enviar el correo',
                    color: 'red'
                })
            }
            this.loadingCorreo = false
        },

          async generateOS() {
            console.log('generateOS called')
            console.log('isProvincia:', this.isProvincia)
            console.log('isDepartamento:', this.isDepartamento)
            console.log('isDistrito:', this.isDistrito)
            console.log('fullNameReceptor:', this.datos.atributos.fullNameReceptor)
            console.log('listService length:', this.listService.length)
            if (this.isProvincia && this.isDepartamento && this.isDistrito && this.datos.atributos.fullNameReceptor && this.listService.length > 0) {
                const departamento = this.departamentos.find((x) => x.id == this.isDepartamento).name
                const provincia = this.provincias.find((x) => x.id == this.isProvincia).name
                const distrito = this.distritos.find((x) => x.id == this.isDistrito).name
                const sede = this.sedes.find((x) => x.id == this.user.idSede).sede_name_id
                const custom_data = {
                    numeroDocumento: this.datos.numeroDocumento,

                    id: this.datos.id,
                    full_name: this.datos.full_name,
                    service: this.datos.service,
                    importeAbonadoSoles: this.datos.importeAbonadoSoles,
                    sede,
                    atributos: this.datos.atributos,
                    correo: this.user.correo,
                    celularVendedora: this.user.telefono,
                    celularContacto: this.datos.celularContacto,
                    direccion: this.datos.direccion,
                    departamento,
                    provincia,
                    distrito,
                    vendedora: this.user.nombres + '' + this.user.apellidos,

                }
                const payload = {
                    personalCargo: this.datos.atributos.encargadoOrdenServicio,
                    fechaEmision: new Date(),
                    ordenPedido: this.datos.id,
                    producto: this.listService[0].description,
                    items: this.listService,
                    customData: custom_data,
                    status: 1
                }
                const result = await this.postAddOS(payload)
                await this.$store.dispatch('printer/ordenService', { ...custom_data, id: result.data.id })
            } else {
                this.$store.commit('mainUI/OPEN_MODAL', {
                    state: true,
                    text: 'Complete todos los campos para continuar',
                    color: 'green'
                })
                await sleep(2500)
                this.$store.commit('mainUI/OPEN_MODAL', { state: false })
            }


        },
        getService(payload) {
            //console.log('payload....', payload)
            const body = {
                ...payload,
                rename: payload.massage,
                description: payload.description,
                hoursTime: payload.hours,
                quantity: payload.quantity,
                price: payload.price,
                comision: payload.comision,
                descuentos: payload.descuentos,
                 subTotal: payload.subTotal
            }
            this.listAllService = body
        }
    }
}
</script>
